<template>
  <!-- <a class="logo" href="javascript:" title="GoFoodie 美食快一點! 辦公室美食外送"></a> -->
  <div>
    <a class="logo" href="javascript:"><img :src="logo"/></a>
    <div v-if="$router.currentRoute.meta.auth">
      <Auth v-if="noAuth !== 'true'" />
    </div>
  </div>
</template>

<script>
import Auth from "@/components/Auth.vue";

export default {
  name: "Header",
  components: {
    Auth,
  },
  data() {
    return {};
  },
  computed: {
    logo() {
      return GLOBAL_ENV_LOGO;
    },
  },
  methods: {
    changeLanguage(lang) {
      this.language = lang;
      // lang: this.$store.state.lang, // get lang 預設值 `en`
      this.$i18n.locale = lang;
    },
  },
  created() {
    // taiwan default
    this.changeLanguage("tw"); // 這個動作坐在這邊，沒用到header的頁面就要記得切
    // this.changeCurrency("NTD");
  },
  props: {
    msg: String,
    noAuth: String
  },
};
</script>
